import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { getUserData } from "../utils/localStorage";
import { errorMessage } from "../utils/alertMessage";
import { getLead } from "../services/leads";

const DashboardSuperTeleCaller = () => {
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { userProfileData } = getUserData();

  const toggleFilter = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const [leadData, setLeadData] = useState([])

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 20,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: ["RECEIVE"],
    sourceIn: [],

  };

  const fetchData = (data) => {
  
      getLead(data)
        .then((response) => {
          if (!response.data.error) {
  
            const rawData = response.data.data || response.data;
   
              setLeadData(rawData);
            
          } else {
            errorMessage("Invalid Credentials");
          }
        })
        .catch(() => {
          errorMessage();
        })
    };

  useEffect(() => {
    fetchData(typeData);
  }, [])

  return (
    <main id="main" className="main">
      <section className="section dashboard">
        <div className="row">
          {/* Left side columns */}
          <div className="col-lg-12">
            <div className="row">
              {/* Sales Card */}
              <div className=" col-md-12">
                <div className="card info-card sales-card">
                  <div className="card-body">
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h5 className="card-title">
                        Super Tele Caller Dashboard <span>| Financeseva</span>
                      </h5>
                      <i
                        className="pi pi-filter-fill"
                        onClick={toggleFilter}
                        style={{ color: "#1e439b" }}
                      ></i>
                    </div>
                    <div className="row">
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Lead Box - {leadData.length} Leads
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default DashboardSuperTeleCaller;
